import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { useToast } from '../../context/ToastContext';
import { FiGrid, FiMail, FiLock, FiArrowRight } from 'react-icons/fi';

const LoginPage = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const { login } = useAuth();
  const { showToast } = useToast();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email || !password) {
      showToast('Please enter your email and password', 'error');
      return;
    }

    setSubmitting(true);
    try {
      const res = await login(email, password);
      showToast('Logged in successfully!', 'success');
      
      // FIX: Check if business exists properly
      if (res.data.role === 'admin') {
        navigate('/admin');
      } else if (!res.data.business) {
        // If no business data exists, go to setup
        navigate('/setup-business');
      } else {
        // Business exists, go to dashboard
        navigate('/dashboard');
      }
    } catch (err) {
      showToast(err.message || 'Login failed. Please check your credentials.', 'error');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className='loginfam' style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#0F172A', padding: '1.5rem' }}>
      <img src='/assets/dklogo.png' />
      <div className="glass-card loginfamcard" style={{ width: '100%', maxWidth: '440px', padding: '2.5rem 2rem' }}>
        <div style={{ textAlign: 'center', marginBottom: '2rem' }}>
          {/* <Link to="/" className="brand-logo" style={{ justifyContent: 'center', marginBottom: '1rem' }}>
            <div className="brand-badge">
              <FiGrid />
            </div>
            <span>Digital Business Kit</span>
          </Link> */}
          <img className='hidelogo' src='/assets/metlogo.png' alt='' />
          <h2 style={{ fontFamily: 'var(--font-heading)', fontSize: '1.5rem', fontWeight: 700 }}>Welcome Back</h2>
          <p style={{ color: '#94A3B8', fontSize: '0.9rem', marginTop: '0.25rem' }}>Sign in to manage your digital business</p>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label className="form-label">Email Address</label>
            <div style={{ position: 'relative' }}>
              <input
                type="email"
                required
                className="form-control"
                style={{ paddingLeft: '2.5rem' }}
                placeholder="name@example.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
              <FiMail style={{ position: 'absolute', left: '12px', top: '12px', color: '#94A3B8' }} />
            </div>
          </div>

          <div className="form-group">
            <label className="form-label">Password</label>
            <div style={{ position: 'relative' }}>
              <input
                type="password"
                required
                className="form-control"
                style={{ paddingLeft: '2.5rem' }}
                placeholder="••••••••"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
              <FiLock style={{ position: 'absolute', left: '12px', top: '12px', color: '#94A3B8' }} />
            </div>
          </div>

          <button type="submit" disabled={submitting} className="btn btn-primary" style={{ width: '100%', marginTop: '1rem' }}>
            {submitting ? 'Signing in...' : 'Sign In'} <FiArrowRight />
          </button>
        </form>

        <div style={{ marginTop: '1.75rem', textAlign: 'center', fontSize: '0.9rem', color: '#94A3B8' }}>
          Don't have an account?{' '}
          <Link to="/register" style={{ color: 'var(--primary-500)', fontWeight: 600 }}>
            Create Account
          </Link>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;